import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IFAQAddPayload, IFAQUpdatePayload } from './platform-faq.interface';

@Injectable({
  providedIn: 'root'
})
export class PlatformFaqService {
  private token!: string;
  private basePath = environment.interop.basePath;
	private httpOptions: any;
	private getFAQsDTUrl = this.basePath + environment.interop.urbanism.nomenclatoare.platformFAQ.getPlatformFAQs + '-dt';
	private getFAQsUrl = this.basePath + environment.interop.urbanism.nomenclatoare.platformFAQ.getPlatformFAQs;
	private storeFAQUrl = this.basePath + environment.interop.urbanism.nomenclatoare.platformFAQ.storePlatformFAQ;
	private updateFAQUrl = this.basePath + environment.interop.urbanism.nomenclatoare.platformFAQ.putPlatformFAQ;
	private deleteFAQUrl = this.basePath + environment.interop.urbanism.nomenclatoare.platformFAQ.deletePlatformFAQ;
	private getFAQsActiveUrl = this.basePath + environment.interop.urbanism.nomenclatoare.platformFAQ.getPlatformFAQsActive;

  constructor(private http: HttpClient) { }

  getFAQsDT() {
		return this.http.get(this.getFAQsDTUrl, this.httpOptions);
	}

  getFAQs(platformSectionID: number) {
		return this.http.get(this.getFAQsUrl + `?section_id={${platformSectionID}}`, this.httpOptions);
	}

	addFAQ(data: IFAQAddPayload) {
		return this.http.post(this.storeFAQUrl, data, this.httpOptions);
	}

	updateFAQ(data: IFAQUpdatePayload) {
		return this.http.put(this.updateFAQUrl, data, this.httpOptions);
	}

	deleteFAQ(requestFAQId: number) {
		return this.http.delete(this.deleteFAQUrl + requestFAQId);
	}

	getActiveFAQs(platformSectionID: number) {
		return this.http.get(this.getFAQsActiveUrl + `?section_id={${platformSectionID}}`, this.httpOptions);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${this.token}`
			})
		};
	}
}
